import { useTranslation } from "react-i18next";

import { l } from "@aviary/locales/i18n";
import type { AviarySize, LayoutStyles } from "@aviary/types";

import GoldSVGComponent from "../assets/Gold";
import SilverSVGComponent from "../assets/Silver";

type QualityPartnerType = "Gold" | "Silver";

import * as styles from "./QualityPartnerBadge.styles";

interface Props {
  /**
   * Determines if Gold or Silver badge is rendered
   */
  qualityPartner: QualityPartnerType;
  /**
   * Size of the badge
   */
  size?: Extract<AviarySize, "xsmall" | "small" | "large">;
  /**
   * Allows you to pass custom styles, use sparingly!
   */
  layoutStyles?: LayoutStyles;
}

const QualityPartnerBadge = ({ qualityPartner, size = "small", layoutStyles }: Props) => {
  const { t } = useTranslation();

  const iconStyles = [
    styles.icon.base,
    styles.icon[qualityPartner],
    styles.icon[size],
    layoutStyles,
  ];

  if (!qualityPartner) return null;

  if (qualityPartner === "Gold") {
    return (
      <GoldSVGComponent
        data-testid="gold-quality-partner"
        aria-label={t(l.aviary.productImage.gold)}
        css={iconStyles}
      />
    );
  }

  return (
    <SilverSVGComponent
      data-testid="silver-quality-partner"
      aria-label={t(l.aviary.productImage.silver)}
      css={iconStyles}
    />
  );
};

export { QualityPartnerBadge, type QualityPartnerType };
